export const getMapSettings = type => {
  switch (type) {
    case "get-in-touch":
      return {
        config: getInTouchMapConfig,
        marker: getInTouchMarkerConfig
      };

    case "about-hub":
      return {
        config: aboutHubMapConfig,
        marker: aboutHubMarkerConfig
      };

    case "locations":
      return {
        config: locationsConfig,
        marker: locationsMarkerConfig,
        cluster: locationsClusterConfig,
        selected: locationsSelectedMarkerConfig
      };

    default:
      return {
        config: getInTouchMapConfig,
        marker: getInTouchMarkerConfig
      };
  }
};

export const locationsMarkerConfig = {
  icon: {
    scaledSize: { width: 42, height: 54 },
    url: "barilla-drop-marker.svg",
    labelOrigin: { x: 21, y: 20 }
  },
  label: {
    text: "1",
    color: "white",
    fontSize: "20px"
  }
};

export const locationsSelectedMarkerConfig = {
  icon: {
    scaledSize: { width: 42, height: 54 },
    url: "selected-marker-drop.svg",
    labelOrigin: { x: 21, y: 20 }
  },
  label: {
    text: "1",
    color: "#00317C",
    fontSize: "20px"
  }
};

export const locationsClusterConfig = {
  icon: {
    scaledSize: { width: 53, height: 53 },
    anchor: { x: 20, y: 20 },
    url: "barilla-drop-marker.svg",
    labelOrigin: { x: 27, y: 20 }
  },
  label: {
    color: "white",
    fontSize: "20px"
  }
};

export const locationsConfig = {
  disableDefaultUI: true,
  draggable: true,
  // scrollwheel: true,
  disableDoubleClickZoom: true,
  zoom: 5,
  minZoom: 3,
  maxZoom: 15,
  zoomControl: true,
  styles: [
    // see https://developers.google.com/maps/documentation/javascript/style-reference
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }, { visibility: "off" }]
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }, { visibility: "off" }]
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ff00f7" }, { visibility: "off" }]
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }, { visibility: "off" }]
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }, { visibility: "off" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }, { visibility: "off" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }, { visibility: "off" }]
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }, { visibility: "off" }]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }, { visibility: "off" }]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [{ color: "#fdf8ea" }]
    }
  ]
};

export const getInTouchMapConfig = {
  zoom: 15,
  disableDefaultUI: true,
  draggable: true,
  // scrollwheel: true,
  disableDoubleClickZoom: true,
  styles: [
    {
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5"
        }
      ]
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#f5f5f5"
        }
      ]
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [
        {
          color: "#5e5e5e"
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "administrative.country",
      elementType: "labels",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "administrative.locality",
      elementType: "labels",
      stylers: [
        {
          color: "#5e5e5e"
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "administrative.province",
      elementType: "labels",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5"
        }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        {
          color: "#dadada"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#5e5e5e"
        }
      ]
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5"
        }
      ]
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#c9c9c9"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#343434"
        }
      ]
    }
  ]
};

export const getInTouchMarkerConfig = {
  icon: {
    scaledSize: { width: 40, height: 40 },
    anchor: { x: 20, y: 20 },
    url: "blue-map-marker.svg"
  }
};

export const aboutHubMapConfig = {
  zoom: 15,
  disableDefaultUI: true,
  draggable: true,
  // scrollwheel: true,
  disableDoubleClickZoom: true,
  styles: [
    {
      elementType: "labels",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [
        {
          color: "#e7edee"
        }
      ]
    },
    {
      featureType: "administrative.land_parcel",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "administrative.neighborhood",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "landscape",
      stylers: [
        {
          color: "#d5d5d5"
        }
      ]
    },
    {
      featureType: "poi",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "water",
      stylers: [
        {
          color: "#fefbf3"
        }
      ]
    }
  ]
};

export const aboutHubMarkerConfig = {
  icon: {
    scaledSize: { width: 40, height: 40 },
    anchor: { x: 20, y: 20 },
    url: "blue-map-marker.svg"
  }
};